module.exports = "<mat-toolbar color=\"primary\">\n  <nav>\n    <a routerLink=\"/dashboard\" routerLinkActive=\"active\">\n      Home\n    </a>\n    <a routerLink=\"/database\" routerLinkActive=\"active\">\n      Database\n    </a>\n    <a routerLink=\"/links\" routerLinkActive=\"active\">Links</a>\n    <a routerLink=\"/profile\" routerLinkActive=\"active\">Profile</a>\n  </nav>\n</mat-toolbar>\n<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// /workspace/chess.arska.org/chess/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main